'use client';

import { c as _c } from "react/compiler-runtime";
import { useBackerRewards } from '@/hooks/trading/use-backer-rewards';
import { BackerRewardsCardView } from './backer-rewards-card-view';
import { createBackerRewardsView } from './backer-rewards-placement';
export interface BackerRewardsCardProps {
  marketPubkey: string;
  marketStatus: string;
  className?: string;
}

/**
 * Backer Rewards card — connected wrapper. Reads all state from
 * `useBackerRewards`, derives the five-state discriminant, and renders the
 * presentational {@link BackerRewardsCardView}. Sits directly below the Prize
 * Pool card on the market detail page.
 */
export function BackerRewardsCard(t0) {
  const $ = _c(8);
  const {
    marketPubkey,
    marketStatus,
    className
  } = t0;
  let t1;
  if ($[0] !== marketPubkey || $[1] !== marketStatus) {
    t1 = {
      marketPubkey,
      marketStatus
    };
    $[0] = marketPubkey;
    $[1] = marketStatus;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rewards = useBackerRewards(t1);
  let t2;
  if ($[3] !== rewards) {
    t2 = createBackerRewardsView(rewards);
    $[3] = rewards;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const view = t2;
  let t3;
  if ($[5] !== className || $[6] !== view) {
    t3 = <BackerRewardsCardView {...view} className={className} />;
    $[5] = className;
    $[6] = view;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}